import { type PropsWithChildren } from "react";

import type {
    PropsWithStyleX,
    QueryMdMaxToMdMin,
    QuerySmMaxToSmMin,
    QueryXsMax,
    QueryXsMin,
} from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

const xsMax: QueryXsMax = "@media (max-width: 759px)";
const xsMin: QueryXsMin = "@media (max-width: 480px)";
const smMinSmMax: QuerySmMaxToSmMin = "@media (max-width: 989px) and (min-width: 760px)";
const mdMinMdMax: QueryMdMaxToMdMin = "@media (max-width: 1239px) and (min-width: 990px)";

const styles = stylex.create({
    container: {
        margin: { default: "20px auto 100px", [xsMax]: "15px auto 50px" },
        padding: { default: null, [xsMax]: "0 20px", [xsMin]: "0 10px" },
        height: "100%",
        width: { default: "1120px", [mdMinMdMax]: "920px", [smMinSmMax]: "670px", [xsMax]: "100%" },
    },
});

type IContainer = PropsWithChildren<PropsWithStyleX>;

export default function Container({ children, styleX }: IContainer) {
    return <div {...stylex.props(styles.container, styleX)}>{children}</div>;
}
